import Rating from '@mui/lab/Rating';
import React, { useEffect } from 'react';
import {removeDoubleSlash} from '../../../shared/utils/urlUtil'
import './products.scss';
import { pushDataLayerEvent, pushGtagEvent } from '../../../shared/utils/metricManagementUtil';

const Products = props => {

  const { isMobile, product, calification } = props;
  let url = product.image != null ? product.image[0].file.url : 'http://lorempixel.com/200/200/';
  const category = product.category != null ? product.category.title.title : 'Sin categoria';
  const productName = product.productName != null ? product.productName.productName : '';

  let tipoProducto = {
    class: 'f-product-common',
    tag: '',
  };

  if (product.isNewProduct) {
    tipoProducto.class = 'f-product-new';
    tipoProducto.tag = 'Nuevo';
  } else if (product.hasOffer) {
    tipoProducto.class = 'f-product-offer';
    tipoProducto.tag = 'Oferta';
  } else if (product.autoAdvertising) {
    url = isMobile ? product.image[1].file.url : product.image[0].file.url;
    tipoProducto.class = 'f-product-autoAdvertising';
  }

  const datalayerFamiCalculadora = () => {      
    let location=''
    if (typeof window !== 'undefined') {
        location= window.location.href
    }
    pushDataLayerEvent({
      event: 'Interacciones_Producto',
      category: 'Productos',
      action: 'Click',
      label: 'FamiCalculadora',
      location: location,
      user_data: [],
      log_status: ''
    })
  }

  const gTagSelectItem = (item, index, calification) => {
    let location=''
    if (typeof window !== 'undefined') {
      location= window.location.href
    }
    
    const {id, productName, category, commercialPartner, characteristics, productPresentations, slug, contentful_id, metaTitle} = item
    pushGtagEvent({
      event: 'select_item',
      params: {
        ecommerce: {
          items: [{
            item_id: id,
            item_name: productName?.productName||'',
            coupon: 'Ninguno',
            discount: '0',
            index: index,
            item_list_name: category?.title.title||'',
            item_list_id: category?.id||'',
            affiliation: commercialPartner ? commercialPartner : '',
            item_brand: 'Familia',
            item_category: 'Productos',
            item_variant: characteristics ? characteristics[0].title : '',
            price: '0',
            currency: 'COP',
            quantity:  '0',
          }],
        },
        item_list_name: category?.title.title||'',
        item_list_id: category?.id||'',
        units: productPresentations ? `X${productPresentations[0].quantity}` : '0',
        qualification: calification,
        user_data: [],
        log_status: ''
      }
    })
    pushDataLayerEvent({
      event:'product_click',
      single_item_id: contentful_id,
      single_item_name: category?.title.title + ' '+productName?.productName,
      link_text: category?.title.title,
      link_url: location
    })
  }

  const ProductContent = () => (
    <>
      <div className="f-product-tag">{tipoProducto.tag}</div>
      <img className="f-img-products" alt="imagen producto" src={url} />
      {!product.autoAdvertising ? (
        <>
          <a   
            href={ removeDoubleSlash(`/productos/${product.category.slug}${product.slug}calificar`) }
            className={"nostyle"}
          >
            <div className="f-product-rating">
              <Rating
                name="half-rating"
                value={Math.round(calification)}
                readOnly
              />
            </div>
          </a>
          <div className="f-product-divider"></div>
          <div className="f-product-characteristics">
            <span className="f-product-category">{category}</span>
            <h3 className="f-product-name">{productName}</h3>
          </div>
        </>
      ) : 
        <div className='f-product-autoAdvertising-description'>
          <p className='f-product-autoAdvertising-name'>
            ¿Alguna vez has contado cuántos cuadritos de papel gastas?
          </p>
          <p className='f-product-autoAdvertising-content'>
            Descubre aquí cuánto rinde tu Papel Higiénico Familia®
          </p>
        </div>
      }
    </>
  );
  
  return (
    <div className="f-product-content">
      <div className={'f-product-card ' + tipoProducto.class}>
        {!product.autoAdvertising ? (
          <a
            href={product.urlRedireccion ? product.urlRedireccion : removeDoubleSlash(`/productos/${product.category.slug}${product.slug}`)}
            className={"nostyle"}
            onClick={ () => gTagSelectItem(product, props.index,calification) }
          >
            <ProductContent />
          </a>
        ) : (
          <a
            href={product.slug}
            className={"nostyle"} 
            onClick={ () => {
              if (product.metaTitle === "Autopauta FamiCalculadora"){
                datalayerFamiCalculadora()
              }
            }}
           >
            <ProductContent />
          </a>
        )}
      </div>
    </div>
  );
};

export default Products;